import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c8a214f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-skills-chart" }
const _hoisted_2 = {
  key: 0,
  class: "chart-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading skills data...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "chart-error"
}
const _hoisted_7 = { class: "error-content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 2,
  ref: "containerRef",
  class: "chart-container",
  style: { minHeight: '400px' }
}
const _hoisted_10 = ["width", "height"]
const _hoisted_11 = ["width", "height"]
const _hoisted_12 = { class: "chart-areas" }
const _hoisted_13 = ["d", "fill", "opacity"]
const _hoisted_14 = { class: "chart-axis" }
const _hoisted_15 = ["x1", "y1", "x2", "y2"]
const _hoisted_16 = ["x1", "y1", "x2", "y2"]
const _hoisted_17 = ["x", "y"]
const _hoisted_18 = ["x", "y"]
const _hoisted_19 = {
  key: 0,
  class: "loc-axis"
}
const _hoisted_20 = ["x1", "y1", "x2", "y2"]
const _hoisted_21 = ["x", "y"]
const _hoisted_22 = ["x", "y"]
const _hoisted_23 = {
  key: 0,
  class: "loc-trend"
}
const _hoisted_24 = ["d"]
const _hoisted_25 = ["cx", "cy"]
const _hoisted_26 = {
  key: 0,
  class: "chart-legend"
}
const _hoisted_27 = ["onClick", "onMouseenter"]
const _hoisted_28 = { class: "legend-text" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-tooltip-header" }, "Other Languages/Formats", -1))
const _hoisted_30 = { class: "legend-tooltip-content" }
const _hoisted_31 = {
  key: 0,
  class: "other-languages-list"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-tooltip-section" }, "Languages included:", -1))
const _hoisted_33 = { class: "legend-tooltip-languages" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 0,
  class: "legend-tooltip-more"
}
const _hoisted_36 = {
  key: 1,
  class: "legend-tooltip-item"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-tooltip-extension" }, "No additional languages found", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "file-types-section"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-tooltip-section" }, "Common file types:", -1))
const _hoisted_41 = { class: "legend-tooltip-extension" }
const _hoisted_42 = { class: "legend-tooltip-count" }
const _hoisted_43 = {
  key: 0,
  class: "legend-tooltip-more"
}
const _hoisted_44 = { class: "tooltip-header" }
const _hoisted_45 = { class: "tooltip-skills" }
const _hoisted_46 = { class: "tooltip-skill-info" }
const _hoisted_47 = { class: "tooltip-skill-header" }
const _hoisted_48 = { class: "tooltip-skill-name" }
const _hoisted_49 = { class: "tooltip-skill-score" }
const _hoisted_50 = {
  key: 0,
  class: "tooltip-skill-breakdown"
}
const _hoisted_51 = {
  key: 0,
  class: "tooltip-loc-data"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tooltip-loc-header" }, "Lines of Code", -1))
const _hoisted_53 = { class: "tooltip-loc-metrics" }
const _hoisted_54 = { class: "tooltip-loc-metric" }
const _hoisted_55 = { class: "tooltip-loc-label" }
const _hoisted_56 = { class: "tooltip-loc-value" }
const _hoisted_57 = {
  key: 0,
  class: "tooltip-loc-metric"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltip-loc-label" }, "Added:", -1))
const _hoisted_59 = { class: "tooltip-loc-value" }
const _hoisted_60 = {
  key: 1,
  class: "tooltip-loc-metric"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltip-loc-label" }, "Deleted:", -1))
const _hoisted_62 = { class: "tooltip-loc-value" }
const _hoisted_63 = { class: "tooltip-loc-metric" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltip-loc-label" }, "Commits:", -1))
const _hoisted_65 = { class: "tooltip-loc-value" }
const _hoisted_66 = {
  key: 3,
  class: "chart-branding"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Powered by GitHub Comment Analysis", -1))
const _hoisted_68 = [
  _hoisted_67
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ion_icon, {
                name: "analytics-outline",
                class: "error-icon"
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1),
              (_ctx.error.includes('No skills data'))
                ? (_openBlock(), _createElementBlock("small", _hoisted_8, "Skills data will appear once GitHub comments are analyzed"))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(), _createElementBlock("svg", {
              ref: "chartSvg",
              key: `chart-${_ctx.dataRevision}-${_ctx.svgWidth}-${_ctx.svgHeight}`,
              width: _ctx.svgWidth,
              height: _ctx.svgHeight,
              class: "skills-chart-svg",
              onMousemove: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseMove && _ctx.handleMouseMove(...args))),
              onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
            }, [
              _createElementVNode("rect", {
                width: _ctx.svgWidth,
                height: _ctx.svgHeight,
                class: "chart-background"
              }, null, 8, _hoisted_11),
              _createElementVNode("g", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillPaths, (skillPath) => {
                  return (_openBlock(), _createElementBlock("path", {
                    key: skillPath.skill,
                    d: skillPath.path,
                    fill: skillPath.color,
                    opacity: skillPath.opacity,
                    class: "skill-area"
                  }, null, 8, _hoisted_13))
                }), 128))
              ]),
              _createElementVNode("g", _hoisted_14, [
                _createElementVNode("line", {
                  x1: _ctx.margin.left,
                  y1: _ctx.svgHeight - _ctx.margin.bottom,
                  x2: _ctx.svgWidth - _ctx.margin.right,
                  y2: _ctx.svgHeight - _ctx.margin.bottom,
                  class: "axis-line"
                }, null, 8, _hoisted_15),
                _createElementVNode("line", {
                  x1: _ctx.margin.left,
                  y1: _ctx.margin.top,
                  x2: _ctx.margin.left,
                  y2: _ctx.svgHeight - _ctx.margin.bottom,
                  class: "axis-line"
                }, null, 8, _hoisted_16),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.xAxisLabels, (date, index) => {
                  return (_openBlock(), _createElementBlock("text", {
                    key: index,
                    x: _ctx.getXPosition(new Date(date)),
                    y: _ctx.svgHeight - _ctx.margin.bottom + 15,
                    class: "axis-label",
                    "text-anchor": "middle"
                  }, _toDisplayString(_ctx.formatAxisDate(date)), 9, _hoisted_17))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yAxisLabels, (value, index) => {
                  return (_openBlock(), _createElementBlock("text", {
                    key: 'y-' + index,
                    x: _ctx.margin.left - 10,
                    y: _ctx.getYPosition(value) + 3,
                    class: "axis-label",
                    "text-anchor": "end"
                  }, _toDisplayString(value), 9, _hoisted_18))
                }), 128)),
                (_ctx.showLinesOfCode)
                  ? (_openBlock(), _createElementBlock("g", _hoisted_19, [
                      _createElementVNode("line", {
                        x1: _ctx.svgWidth - _ctx.margin.right,
                        y1: _ctx.margin.top,
                        x2: _ctx.svgWidth - _ctx.margin.right,
                        y2: _ctx.svgHeight - _ctx.margin.bottom,
                        class: "axis-line loc-axis-line"
                      }, null, 8, _hoisted_20),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locAxisLabels, (value, index) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: 'loc-y-' + index,
                          x: _ctx.svgWidth - _ctx.margin.right + 10,
                          y: _ctx.getLocYPosition(value) + 3,
                          class: "axis-label loc-axis-label",
                          "text-anchor": "start"
                        }, _toDisplayString(_ctx.formatLocLabel(value)), 9, _hoisted_21))
                      }), 128)),
                      _createElementVNode("text", {
                        x: _ctx.svgWidth - _ctx.margin.right + 35,
                        y: (_ctx.svgHeight - _ctx.margin.top - _ctx.margin.bottom) / 2 + _ctx.margin.top,
                        class: "axis-title loc-axis-title",
                        "text-anchor": "middle",
                        transform: "rotate(90, svgWidth - margin.right + 35, (svgHeight - margin.top - margin.bottom) / 2 + margin.top)"
                      }, " Lines of Code (" + _toDisplayString(_ctx.locDisplayMode === 'cumulative' ? 'Total' : _ctx.locDisplayMode === 'net' ? 'Net' : 'Added') + ") ", 9, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.showLinesOfCode && _ctx.locData.length > 0)
                ? (_openBlock(), _createElementBlock("g", _hoisted_23, [
                    _createElementVNode("path", {
                      d: _ctx.getLocTrendPath(),
                      class: "loc-trend-line",
                      fill: "none",
                      stroke: "#FF6B6B",
                      "stroke-width": "2",
                      "stroke-dasharray": "4,4",
                      opacity: "0.8"
                    }, null, 8, _hoisted_24),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locData, (point, index) => {
                      return (_openBlock(), _createElementBlock("circle", {
                        key: 'loc-point-' + index,
                        cx: _ctx.getXPosition(point.date),
                        cy: _ctx.getLocYPosition(point.cumulativeLines || 0),
                        r: "3",
                        class: "loc-data-point",
                        fill: "#FF6B6B",
                        opacity: "0.7"
                      }, null, 8, _hoisted_25))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 40, _hoisted_10)),
            (_ctx.showLegend)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legendItems, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.skill,
                      class: _normalizeClass(["legend-item", { 'legend-item--disabled': !item.visible }]),
                      onClick: ($event: any) => (_ctx.toggleSkill(item.skill)),
                      onMouseenter: (e) => _ctx.handleLegendHover(e, item.skill),
                      onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideLegendTooltip && _ctx.hideLegendTooltip(...args)))
                    }, [
                      _createElementVNode("span", {
                        class: "legend-color",
                        style: _normalizeStyle({ backgroundColor: item.color })
                      }, null, 4),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(item.skill), 1)
                    ], 42, _hoisted_27))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.legendTooltip && _ctx.legendTooltip.skill === 'Other')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "legend-tooltip",
                  style: _normalizeStyle({
          left: _ctx.legendTooltip.x + 'px',
          top: _ctx.legendTooltip.y + 'px'
        })
                }, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    (_ctx.otherSkillsList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherSkillsList.slice(0, 12), (lang, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: lang,
                                class: "legend-tooltip-language"
                              }, [
                                _createTextVNode(_toDisplayString(lang), 1),
                                (index < _ctx.otherSkillsList.slice(0, 12).length - 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, ", "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          (_ctx.otherSkillsList.length > 12)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, " +" + _toDisplayString(_ctx.otherSkillsList.length - 12) + " more languages ", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38)),
                    (_ctx.otherBreakdown && _ctx.otherBreakdown.breakdown)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _hoisted_40,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherBreakdown.breakdown.slice(0, 6), (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "legend-tooltip-item"
                            }, [
                              _createElementVNode("span", _hoisted_41, "." + _toDisplayString(item.extension || '(no ext)'), 1),
                              _createElementVNode("span", _hoisted_42, _toDisplayString(item.count) + " files", 1)
                            ]))
                          }), 128)),
                          (_ctx.otherBreakdown.breakdown.length > 6)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, " +" + _toDisplayString(_ctx.otherBreakdown.breakdown.length - 6) + " more types ", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 4))
              : _createCommentVNode("", true),
            (_ctx.showTooltip && _ctx.tooltipData)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "chart-tooltip",
                  style: _normalizeStyle({
          left: _ctx.tooltipData.x + 'px',
          top: _ctx.tooltipData.y + 'px'
        })
                }, [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.tooltipData.date), 1),
                  _createElementVNode("div", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tooltipData.skills, (skill) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: skill.name,
                        class: "tooltip-skill"
                      }, [
                        _createElementVNode("span", {
                          class: "tooltip-skill-color",
                          style: _normalizeStyle({ backgroundColor: skill.color })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", _hoisted_48, _toDisplayString(skill.name) + ":", 1),
                            _createElementVNode("span", _hoisted_49, _toDisplayString(skill.score), 1)
                          ]),
                          (skill.breakdown)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(skill.breakdown), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.showLinesOfCode && _ctx.tooltipData.locData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.locDisplayMode === 'cumulative' ? 'Total' : _ctx.locDisplayMode === 'net' ? 'Net' : 'Added') + ":", 1),
                            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.formatLocLabel(_ctx.tooltipData.locData.value)), 1)
                          ]),
                          (_ctx.locDisplayMode !== 'cumulative')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _hoisted_58,
                                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.formatLocLabel(_ctx.tooltipData.locData.linesAdded)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.locDisplayMode !== 'cumulative')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                _hoisted_61,
                                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.formatLocLabel(_ctx.tooltipData.locData.linesDeleted)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_63, [
                            _hoisted_64,
                            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.tooltipData.locData.commitCount), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 4))
              : _createCommentVNode("", true)
          ], 512)),
    (_ctx.showBranding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_68))
      : _createCommentVNode("", true)
  ]))
}